import React, { Component } from "react";
import { Col, Row, Tab, Tabs, Card, Table, Badge, Alert, Button, Form, Image } from "react-bootstrap";
import "./motorpolicies.css";
import configData from "../../config.json";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import tatalogo from './tataaig.jpeg';


export default class MVehicleInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paamount: sessionStorage.getItem("pa_cover_prem") || 0,
      selectedQuoteData: null,
      proposalId: "",
      isLoading: true,
      activeTab: "vehicle-details"

    };
  }

  componentDidMount() {
    this.loadQuoteData();
  }
  showToast = (msg, type) => {
    const toastMethods = {
      success: toast.success,
      error: toast.error,
      warning: toast.warn,
      info: toast.info
    };
    (toastMethods[type] || toast.success)(msg);
  };

  loadQuoteData = () => {
    try {
      const selectedQuoteData = JSON.parse(sessionStorage.getItem("selectedQuoteData"));
      const proposalId = sessionStorage.getItem("proposal_id");

      if (selectedQuoteData) {
        this.setState({
          selectedQuoteData,
          proposalId: proposalId || "",
          isLoading: false
        });
      } else {
        this.setState({ isLoading: false });
      }
    } catch (error) {
      console.error("Error loading quote data:", error);
      this.setState({ isLoading: false });
    }
  };

  formatCurrency = (amount) => {
    const numAmount = parseFloat(amount) || 0;
    return `₹${numAmount.toLocaleString()}`;
  };

  formatRegistrationNumber = (regno1, regno2, regno3, regno4) => {
    return `${regno1}${String(regno2).padStart(2, '0')}${regno3}${regno4}`;
  };
  handleIDVChange = (newValue) => {
    this.setState((prevState) => ({
      selectedQuoteData: {
        ...prevState.selectedQuoteData,
        data: {
          ...prevState.selectedQuoteData.data,
          vehicle_idv: newValue
        }
      }
    }));
  };

  renderVehicleDetailsTab = () => {
    const { selectedQuoteData } = this.state;
    const data = selectedQuoteData?.data || {};
    const rawData = selectedQuoteData?.raw_data || {};

    return (
      <Card>
        <Card.Header>
          <h5 className="mb-0">Vehicle Information & IDV Details</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Table responsive striped>
                <tbody>
                  <tr>
                    <td><strong>Vehicle Make:</strong></td>
                    <td>{selectedQuoteData?.vehicle_make || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Vehicle Model:</strong></td>
                    <td>{selectedQuoteData?.vehicle_model || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Vehicle Variant:</strong></td>
                    <td>{selectedQuoteData?.vehicle_variant || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Manufacturing Year:</strong></td>
                    <td>{selectedQuoteData?.man_year || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Registration Date:</strong></td>
                    <td>{selectedQuoteData?.dor || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Vehicle Age:</strong></td>
                    <td>{data.vehicleAge ? `${data.vehicleAge} years` : "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Registration Number:</strong></td>
                    <td className="text-monospace">
                      {this.formatRegistrationNumber(
                        selectedQuoteData?.regno_1,
                        selectedQuoteData?.regno_2,
                        selectedQuoteData?.regno_3,
                        selectedQuoteData?.regno_4
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Registration Place:</strong></td>
                    <td>{selectedQuoteData?.place_reg || "N/A"}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>

            <Col md={6}>
              <h6 className="text-primary mb-3">IDV & Valuation Details</h6>
              <Table responsive striped>
                <tbody>
                  <tr>
                    <td><strong>Current IDV:</strong></td>
                    <td>
                      {selectedQuoteData?.vehicle_idv === 0 ? (
                        <Badge bg="info">N/A (SATP Policy)</Badge>
                      ) : (
                        this.formatCurrency(selectedQuoteData?.vehicle_idv)
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Base IDV:</strong></td>
                    <td>
                      {data.baseIDV === 0 ? (
                        <Badge bg="secondary">Not Applicable</Badge>
                      ) : (
                        this.formatCurrency(data.baseIDV)
                      )}
                    </td>
                  </tr>
                  {/* <tr>
                    <td><strong>IDV Range:</strong></td>
                    <td>
                      {data.minimumIDV === 0 && data.maximumIDV === 0 ? (
                        <Badge bg="secondary">Not Applicable</Badge>
                      ) : (
                        <>
                          {this.formatCurrency(data.minimumIDV)} – {this.formatCurrency(data.maximumIDV)}
                        </>
                      )}
                    </td>
                  </tr> */}
                  <tr>
                    <td><strong>IDV Range:</strong></td>
                    <td>
                      {data.minimumIDV === 0 && data.maximumIDV === 0 ? (
                        <Badge bg="secondary">Not Applicable</Badge>
                      ) : (
                        <>
                          <Form.Range
                            min={data.minimumIDV}
                            max={data.maximumIDV}
                            step="100"
                            title={`Current IDV: ₹${data.vehicle_idv}`}
                            value={data.vehicle_idv || data.baseIDV || data.minimumIDV}
                            onChange={(e) =>
                              this.handleIDVChange(parseFloat(e.target.value))
                            }
                          />
                          <div className="d-flex justify-content-between mt-1">
                            <small>{this.formatCurrency(data.minimumIDV)}</small>
                            <strong className="text-primary">{this.formatCurrency(data.vehicle_idv || data.baseIDV || data.minimumIDV)}</strong>
                            <small>{this.formatCurrency(data.maximumIDV)}</small>
                          </div>
                        </>
                      )}
                    </td>
                  </tr>


                  <tr>
                    <td><strong>Ex-Showroom Price:</strong></td>
                    <td>{this.formatCurrency(data.ex_showroom_price)}</td>
                  </tr>
                  <tr>
                    <td><strong>Make Code:</strong></td>
                    <td>{data.vehicle_make_no || rawData.make_code || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Model Code:</strong></td>
                    <td>{data.vehicle_model_no || rawData.model_code || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Variant Code:</strong></td>
                    <td>{data.vehicle_variant_no || rawData.variant_code || "N/A"}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>

          {selectedQuoteData?.plan_type?.includes("SATP") && (
            <Alert variant="info" className="mt-3">
              <strong>Note:</strong> This is a Standalone Third Party (SATP) policy.
              IDV values are not applicable as this policy only covers third-party liability.
            </Alert>
          )}
        </Card.Body>
      </Card>
    );
  };
  renderPremiumBreakupTab = () => {
    const { selectedQuoteData } = this.state;
    const premium = selectedQuoteData?.premium_break_up || {};
    const od = premium.total_od_premium?.od || {};
    const tp = premium.total_tp_premium || {};
    const addOns = premium.total_addOns || {};
    const discount = premium.total_od_premium?.discount_od || {};

    return (
      <Card>
        <Card.Header>
          <h5 className="mb-0">Premium Break-up Details</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <h6 className="text-primary mb-3">Own Damage (OD) Premiums</h6>
              <Table responsive striped>
                <tbody>
                  <tr><td><strong>Basic OD:</strong></td><td>{this.formatCurrency(od.basic_od)}</td></tr>
                  <tr><td><strong>Electrical Accessories:</strong></td><td>{this.formatCurrency(od.electrical_prem)}</td></tr>
                  <tr><td><strong>Non-Electrical Accessories:</strong></td><td>{this.formatCurrency(od.non_electrical_prem)}</td></tr>
                  <tr><td><strong>CNG/LPG OD Premium:</strong></td><td>{this.formatCurrency(od.cng_lpg_od_prem)}</td></tr>
                  <tr className="table-success">
                    <td><strong>Total OD Premium:</strong></td>
                    <td><strong>{this.formatCurrency(premium.total_od_premium?.total_od)}</strong></td>
                  </tr>
                </tbody>
              </Table>

              <h6 className="text-primary mb-3 mt-4">OD Discounts</h6>
              <Table responsive striped>
                <tbody>
                  <tr><td><strong>Anti-theft Discount:</strong></td><td>{this.formatCurrency(discount.disc_antitheft_prem)}</td></tr>
                  <tr><td><strong>Voluntary Deductible:</strong></td><td>{this.formatCurrency(discount.voluntary_prem)}</td></tr>
                  <tr><td><strong>Auto Association Discount:</strong></td><td>{this.formatCurrency(discount.disc_auto_asso_prem)}</td></tr>
                </tbody>
              </Table>
            </Col>

            <Col md={6}>
              <h6 className="text-primary mb-3">Third Party (TP) Premiums</h6>
              <Table responsive striped>
                <tbody>
                  <tr><td><strong>Basic TP:</strong></td><td>{this.formatCurrency(tp.basic_tp_prem)}</td></tr>
                  <tr><td><strong>Disc Limited Own TP_Premium:</strong></td><td>{this.formatCurrency(tp.disc_limited_own_tp_prem)}</td></tr>
                  <tr><td><strong>PA Cover Premium:</strong></td><td>{this.formatCurrency(tp.pa_cover_prem)}</td></tr>
                  <tr><td><strong>Disc TPPD Premium:</strong></td><td>{this.formatCurrency(tp.disc_tppd_prem)}</td></tr>
                  <tr><td><strong>Cng lpg TP Premium:</strong></td><td>{this.formatCurrency(tp.cng_lpg_tp_prem)}</td></tr>
                  <tr><td><strong>Reliability Trials TP Premium:</strong></td><td>{this.formatCurrency(tp.reliability_trials_tp_prem)}</td></tr>
                  <tr><td><strong>Geo Extension TP Premium:</strong></td><td>{this.formatCurrency(tp.geo_extension_tp_prem)}</td></tr>
                  <tr><td><strong>PA Paid Driver Premium</strong></td><td>{this.formatCurrency(tp.pa_paid_driver_prem)}</td></tr>
                  <tr><td><strong>PA Unnamed Premium</strong></td><td>{this.formatCurrency(tp.pa_unnamed_prem)}</td></tr>
                  <tr><td><strong>addi_pa_own_drive_prem</strong></td><td>{this.formatCurrency(tp.addi_pa_own_drive_prem)}</td></tr>
                  <tr><td><strong>addi_pa_unnamed_prem</strong></td><td>{this.formatCurrency(tp.addi_pa_unnamed_prem)}</td></tr>
                  <tr><td><strong>ll_paid_driver_prem</strong></td><td>{this.formatCurrency(tp.ll_paid_driver_prem)}</td></tr>
                  <tr><td><strong>ll_paid_employee_prem</strong></td><td>{this.formatCurrency(tp.ll_paid_employee_prem)}</td></tr>
                  <tr><td><strong>addi_tppd_prem</strong></td><td>{this.formatCurrency(tp.addi_tppd_prem)}</td></tr>

                  <tr><td><strong>TPPD Discount:</strong></td><td>{this.formatCurrency(tp.disc_tppd_prem)}</td></tr>
                  <tr className="table-success">
                    <td><strong>Total TP Premium:</strong></td>
                    <td><strong>{this.formatCurrency(tp.total_tp_prem)}</strong></td>
                  </tr>
                </tbody>
              </Table>

              <h6 className="text-primary mb-3 mt-4">Taxes & Totals</h6>
              <Table responsive striped>
                <tbody>
                  <tr><td><strong>IGST:</strong></td><td>{this.formatCurrency(premium.igst_prem)}</td></tr>
                  <tr><td><strong>CGST:</strong></td><td>{this.formatCurrency(premium.cgst_prem)}</td></tr>
                  <tr><td><strong>SGST:</strong></td><td>{this.formatCurrency(premium.sgst_prem)}</td></tr>
                  <tr><td><strong>Net Premium:</strong></td><td>{this.formatCurrency(premium.net_premium)}</td></tr>
                  <tr className="table-primary">
                    <td><strong>Final Premium:</strong></td>
                    <td><strong>{this.formatCurrency(premium.final_premium)}</strong></td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };

  renderPolicyDetailsTab = () => {
    const { selectedQuoteData } = this.state;
    const polDetails = selectedQuoteData?.pol_dlts || {};

    return (
      <Card>
        <Card.Header>
          <h5 className="mb-0">Policy & Plan Information</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <h6 className="text-primary mb-3">Policy Details</h6>
              <Table responsive striped>
                <tbody>
                  <tr>
                    <td><strong>Quote ID:</strong></td>
                    <td className="text-monospace">{selectedQuoteData?.quote_id || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Proposal ID:</strong></td>
                    <td className="text-monospace">{selectedQuoteData?.proposal_id || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Policy ID:</strong></td>
                    <td className="text-monospace">{selectedQuoteData?.policy_id || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Quote Number:</strong></td>
                    <td className="text-monospace">{selectedQuoteData?.quote_no || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Business Type:</strong></td>
                    <td>
                      <Badge bg={selectedQuoteData?.business_type === "Roll Over" ? "success" : "primary"}>
                        {selectedQuoteData?.business_type || "N/A"}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Proposer Type:</strong></td>
                    <td>{selectedQuoteData?.proposer_type || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Plan Type:</strong></td>
                    <td>
                      <Badge bg="info">{selectedQuoteData?.plan_type || "N/A"}</Badge>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>

            <Col md={6}>
              <h6 className="text-primary mb-3">Coverage Details</h6>
              <Table responsive striped>
                <tbody>
                  <tr>
                    <td><strong>TP Tenure:</strong></td>
                    <td>{polDetails.tp_tenure ? `${polDetails.tp_tenure} years` : "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Current NCB:</strong></td>
                    <td>{polDetails.pp_curr_ncb || 0}%</td>
                  </tr>
                  <tr>
                    <td><strong>Total Discount:</strong></td>
                    <td>{this.formatCurrency(polDetails.total_discount)}</td>
                  </tr>
                  <tr>
                    <td><strong>Basic OD Premium:</strong></td>
                    <td>{this.formatCurrency(polDetails.basic_od)}</td>
                  </tr>
                  <tr>
                    <td><strong>Referral Required:</strong></td>
                    <td>
                      <Badge bg={polDetails.refferal ? "warning" : "success"}>
                        {polDetails.refferal ? "Yes" : "No"}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Break-in Period:</strong></td>
                    <td>{selectedQuoteData?.data?.hasBreakIn || "No"}</td>
                  </tr>
                  <tr>
                    <td><strong>Break-in Days:</strong></td>
                    <td>{selectedQuoteData?.data?.breakInDays || 0} days</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };

  renderPolicyDatesTab = () => {
    const { selectedQuoteData } = this.state;
    const rawData = selectedQuoteData?.raw_data || {};

    return (
      <Card>
        <Card.Header>
          <h5 className="mb-0">Policy Dates & Timeline</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <h6 className="text-primary mb-3">Policy Period</h6>
              <Table responsive striped>
                <tbody>
                  <tr>
                    <td><strong>Policy Start Date:</strong></td>
                    <td className="text-success">
                      <strong>{selectedQuoteData?.pol_start_date || "N/A"}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Policy End Date:</strong></td>
                    <td className="text-danger">
                      <strong>{selectedQuoteData?.pol_end_date || "N/A"}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Policy Duration:</strong></td>
                    <td>
                      {selectedQuoteData?.pol_start_date && selectedQuoteData?.pol_end_date ? (
                        <Badge bg="info">
                          {Math.ceil((new Date(selectedQuoteData.pol_end_date) - new Date(selectedQuoteData.pol_start_date)) / (1000 * 60 * 60 * 24 * 365))} years
                        </Badge>
                      ) : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Quote Date & Time:</strong></td>
                    <td>{rawData.quote_datetime || "N/A"}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>

            <Col md={6}>
              <h6 className="text-primary mb-3">Previous Policy Details</h6>
              <Table responsive striped>
                <tbody>
                  <tr>
                    <td><strong>Previous Policy Start:</strong></td>
                    <td>{sessionStorage.getItem("prev_pol_start_date") || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>Previous Policy End:</strong></td>
                    <td>{sessionStorage.getItem("prev_pol_end_date") || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>BLE TP Start:</strong></td>
                    <td>{sessionStorage.getItem("bletpstart") || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>BLE TP End:</strong></td>
                    <td>{sessionStorage.getItem("bletpend") || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>BLE OD Start:</strong></td>
                    <td>{sessionStorage.getItem("bleodstart") || "N/A"}</td>
                  </tr>
                  <tr>
                    <td><strong>BLE OD End:</strong></td>
                    <td>{sessionStorage.getItem("bleodend") || "N/A"}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };

  renderAdditionalCoverTab = () => {
    const { selectedQuoteData } = this.state;
    const addOns = selectedQuoteData?.premium_break_up?.total_addOns || {};
    const data = selectedQuoteData?.data || {};

    return (
      <Card>
        <Card.Header>
          <h5 className="mb-0">Additional Cover & Add-ons Details</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <h6 className="text-primary mb-3">Add-on Premiums</h6>
              <Table responsive striped>
                <tbody>

                  <tr>
                    <td><strong>Depreciation Reimbursement:</strong></td>
                    <td>{this.formatCurrency(addOns.dep_reimburse_prem)}</td>
                  </tr>
                  <tr>
                    <td><strong>Return to Invoice:</strong></td>
                    <td>{this.formatCurrency(addOns.return_invoice_prem)}</td>
                  </tr>
                  <tr>
                    <td><strong>Consumable Expenses:</strong></td>
                    <td>{this.formatCurrency(addOns.consumbale_expense_prem)}</td>
                  </tr>
                  <tr>
                    <td><strong>Emergency Medical Expenses:</strong></td>
                    <td>{this.formatCurrency(addOns.emergency_medical_expense_prem)}</td>
                  </tr>
                  <tr>
                    <td><strong>Road Side Assistance:</strong></td>
                    <td>{this.formatCurrency(addOns.rsa_prem)}</td>
                  </tr>
                  <tr>
                    <td><strong>NCB Premium:</strong></td>
                    <td>{this.formatCurrency(addOns.ncb_prem)}</td>
                  </tr>
                  <tr>
                    <td><strong>Engine Secure:</strong></td>
                    <td>{this.formatCurrency(addOns.engine_secure_prem)}</td>
                  </tr>
                  <tr>
                    <td><strong>Tyre Secure:</strong></td>
                    <td>{this.formatCurrency(addOns.tyre_secure_prem)}</td>
                  </tr>
                  <tr className="table-success">
                    <td><strong>Total Add-on Premium:</strong></td>
                    <td><strong>{this.formatCurrency(addOns.total_addon)}</strong></td>
                  </tr>
                </tbody>
              </Table>
            </Col>

            <Col md={6}>
              <h6 className="text-primary mb-3">Inspection & Special Features</h6>
              <Table responsive striped>
                <tbody>
                  <tr>
                    <td><strong>Vehicle Inspection Required:</strong></td>
                    <td>
                      <Badge bg={data.vehicleInspectionFlag ? "warning" : "success"}>
                        {data.vehicleInspectionFlag ? "Yes" : "No"}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Self Inspection:</strong></td>
                    <td>
                      <Badge bg={data.selfInspection ? "info" : "secondary"}>
                        {data.selfInspection ? "Allowed" : "Not Allowed"}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Third Party Inspection:</strong></td>
                    <td>
                      <Badge bg={data.thirdPartyInspection ? "info" : "secondary"}>
                        {data.thirdPartyInspection ? "Required" : "Not Required"}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Inspection Validity:</strong></td>
                    <td>{data.inspectionValidity || 0} days</td>
                  </tr>
                  <tr>
                    <td><strong>RSD Days:</strong></td>
                    <td>{data.rsdDays || 0} days</td>
                  </tr>
                  <tr>
                    <td><strong>Gender Discount:</strong></td>
                    <td>{this.formatCurrency(data.genderDiscount)}</td>
                  </tr>
                  <tr>
                    <td><strong>Add-on Bundle:</strong></td>
                    <td>{data.addOnBundle || "None"}</td>
                  </tr>

                </tbody>
              </Table>

              {data.underwritingMessages?.length > 0 && (
                <div className="mt-3">
                  <h6 className="text-warning">Underwriting Messages</h6>
                  <ul className="list-unstyled">
                    {data.underwritingMessages.map((msg, index) => (
                      <li key={index}>
                        <Badge bg="warning" className="me-2">UW</Badge>
                        {msg}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {data.declines?.length > 0 && (
                <Alert variant="danger" className="mt-3">
                  <strong>Declines:</strong>
                  <ul className="mb-0 mt-2">
                    {data.declines.map((decline, index) => (
                      <li key={index}>{decline}</li>
                    ))}
                  </ul>
                </Alert>
              )}

              {data.referrals?.length > 0 && (
                <Alert variant="warning" className="mt-3">
                  <strong>Referrals:</strong>
                  <ul className="mb-0 mt-2">
                    {data.referrals.map((referral, index) => (
                      <li key={index}>{referral}</li>
                    ))}
                  </ul>
                </Alert>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };

  handleNext = () => {
    // Navigate to next step - customer details
    window.location.href = "/mproposelsummary";
  };

  handleBack = () => {
    // Go back to quotes page
    window.location.href = "/mquotes";
  };
  MotorQuoteLatestIDVSubmitHandler = async (e) => {
    e.preventDefault();

    try {
      // 1️⃣ Get the latest IDV value (from slider or state)
      const latestIDV = this.state.vehicle_idv || this.state.selectedQuoteData?.data?.vehicle_idv || "";

      if (!latestIDV || latestIDV === 0) {
        this.showToast("Please adjust IDV range before submitting.", "error");
        return;
      }

      // 2️⃣ Retrieve stored motorQuoteRequest JSON
      const storedQuote = sessionStorage.getItem("motorQuoteRequest");
      if (!storedQuote) {
        this.showToast("No base quotation data found in session.", "error");
        return;
      }

      // 3️⃣ Parse and update vehicle_idv
      let jsonData = JSON.parse(storedQuote);
      jsonData.vehicle_idv = latestIDV;

      console.log("📦 Updated JSON for IDV quote:", jsonData);

      // 4️⃣ Save updated JSON back to sessionStorage
      sessionStorage.setItem("motorQuoteRequest", JSON.stringify(jsonData));

      // 5️⃣ Prepare FormData for API submission
      const formData = new FormData();
      formData.append("sId", this.state.sId || "");
      formData.append("uId", this.state.uId || "");
      formData.append("integId", 327);
      formData.append("savedata", "yes");
      formData.append("jsonData", JSON.stringify(jsonData));

      // 6️⃣ Call API
      const response = await fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
        method: "POST",
        mode: "cors",
        body: formData,
      });

      const data = await response.json();
      console.log("🚀 API Response for Latest IDV Quote:", data);

      // 7️⃣ Show toast and redirect if successful
      if (data.status === "success") {
        this.showToast("Quote generated successfully with latest IDV!", "success");
        sessionStorage.setItem("requestId", data.requestId);
        sessionStorage.setItem("motorQuoteResponse", JSON.stringify(data));
        setTimeout(() => (window.location.href = "/mquote"), 1500);
      } else {
        this.showToast(data.message || "Failed to generate quote.", "error");
      }
    }
    catch (error) {
      // console.error("❌ Error submitting latest IDV quote:", error);
      // this.showToast("Something went wrong while fetching quote.", "error");
    }
  };


  render() {
    const { selectedQuoteData, isLoading } = this.state;

    if (isLoading) {
      return (
        <div className="text-center mt-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <h5 className="mt-3">Loading Vehicle Information...</h5>
        </div>
      );
    }

    if (!selectedQuoteData) {
      return (
        <div className="text-center mt-5">
          <Alert variant="warning">
            <h5>No Quote Data Found</h5>
            <p>Please go back to the quotes page and select a quote.</p>
            <Button variant="primary" onClick={this.handleBack}>
              Go Back to Quotes
            </Button>
          </Alert>
        </div>
      );
    }

    return (
      <div className="bgalphacolor">
        <h3 className="logoskybluecolor">Vehicle Information Details</h3>

        {/* Progress Steps */}
        <Row className="mb-4">

          <Col className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi-car-front-fill nav-icon">
              <p className="nav-label mt-2">Vehicle Details</p>
            </div>
          </Col>
          <Col className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">Quotes</p>
            </div>
          </Col>
          <Col className="col-md-3 active-page">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Vehicle Info</p>
            </div>
          </Col>
          <Col className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">Customer Details</p>
            </div>
          </Col>
        </Row>

        <Row>
          <Image style={{ width: "auto", height: "100px" }}
            src={tatalogo}
            alt="" />
          <Col lg="12">
            <Tabs
              activeKey={this.state.activeTab}
              onSelect={(k) => this.setState({ activeTab: k })}
              className="mb-3"
            >
              <Tab eventKey="vehicle-details" title="Vehicle Details">
                {this.renderVehicleDetailsTab()}
              </Tab>

              <Tab eventKey="policy-details" title="Policy & Plan Details">
                {this.renderPolicyDetailsTab()}
              </Tab>

              <Tab eventKey="policy-dates" title="Policy Dates">
                {this.renderPolicyDatesTab()}
              </Tab>

              <Tab eventKey="additional-cover" title="Additional Cover Details">
                {this.renderAdditionalCoverTab()}
              </Tab>
              <Tab eventKey="premium-breakup" title="Premium Break-up">
                {this.renderPremiumBreakupTab()}
              </Tab>
            </Tabs>
          </Col>
        </Row>

        {/* Premium Summary */}
        <Row className="mt-4">
          <Col>
            <Card className="shadow-sm">
              <Card.Header className="bg-primary text-white">
                <h5 className="mb-0">Premium Summary</h5>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col md={3}>
                    <div className="text-center">
                      <h6>Personal Accident Premium :</h6>
                      <h4 className="text-success"> {this.formatCurrency(sessionStorage.pa_cover_prem)}</h4>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="text-center">
                      <h6>Net Premium</h6>
                      <h4 className="text-success">{this.formatCurrency(selectedQuoteData.net_premium)}</h4>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="text-center">
                      <h6>GST Amount</h6>
                      <h4 className="text-info">{this.formatCurrency(selectedQuoteData.premium_break_up?.igst_prem)}</h4>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="text-center">
                      <h6>Total Premium</h6>
                      <h4 className="text-primary">{this.formatCurrency(selectedQuoteData.total_premium)}</h4>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Navigation Buttons */}
        <Row className="mt-4">
          <Col className="text-center">
            <Button variant="outline-primary" className="me-3 rounded-0" onClick={this.handleBack}>
              Back to Quotes
            </Button>
            <Button variant="primary"
              className="me-3 rounded-0" onClick={this.MotorQuoteLatestIDVSubmitHandler}>
              Get Quote For Latest IDV
            </Button>

            <Button variant="primary" className="me-3 rounded-0" onClick={this.handleNext}>
              Proceed to Customer Details
            </Button>

          </Col>
        </Row>
      </div>
    );
  }
}